import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';

const Layout = () => {
    const location = useLocation();

    return (
        <div>
            <nav className="nav">
                <div className="nav-container">
                    <h1 className="nav-title">ETL System</h1>
                    <div className="nav-links">
                        <Link
                            to="/"
                            className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                        >
                            Главная
                        </Link>
                        <Link
                            to="/connections"
                            className={location.pathname === '/connections' ? 'nav-link active' : 'nav-link'}
                        >
                            Подключения
                        </Link>
                        <Link
                            to="/queues"
                            className={location.pathname.includes('/queues') ? 'nav-link active' : 'nav-link'}
                        >
                            Очереди
                        </Link>
                        <Link
                            to="/users"
                            className={location.pathname === '/users' ? 'nav-link active' : 'nav-link'}
                        >
                            Пользователи
                        </Link>
                    </div>
                </div>
            </nav>

            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;